import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./TextPlaceholder.module.scss";

function TextPlaceholder({ className }) {
  return <div className={classnames(styles.text_placeholder, className)} />;
}

TextPlaceholder.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

TextPlaceholder.defaultProps = {
  className: null,
};

TextPlaceholder.displayName = "TextPlaceholder";

export default TextPlaceholder;
